module.exports = "<div class=\"weui_cell weui_cell_select\" :class=\"{'weui_select_before': before, 'weui_select_after': after}\">\n  <cell-header v-if=\"before || after\">\n    <cell-select :options=\"options\" :selected.sync=\"selected\" v-if=\"before\"></cell-select>\n    <slot name=\"header\" v-else></slot>\n  </cell-header>\n  <cell-body>\n    <slot name=\"body\" v-if=\"before\"></slot>\n    <cell-select :options=\"options\" :selected.sync=\"selected\" v-else></cell-select>\n  </cell-body>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/select-cell.vue
 ** module id = 97
 ** module chunks = 0
 **/